module.exports = __webpack_public_path__ + "static/media/Building.dfafc45b.jpg";